<div *ngIf="show" class="row mb-3 mb-sm-0">
  <div class="col col-md-8">

    <section i18n-title="Reklama" class="mt-3">
      <mat-expansion-panel expanded="true">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="h6 text-nowrap mt-2" i18n>Reklama</div>
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-container>
          <div class="p-md-2 text-center">
            <a [href]="linkaBannera" target="_blank" class="d-block">
              <img src="{{imgSrc}}" alt="Reklama" width="100%" height="auto" />
            </a>
          </div>
        </ng-container>

      </mat-expansion-panel>

    </section>

  </div>
</div>

